/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCreateCoa = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M5 6.455 12 3l7 3.455v4.181c0 .723-.061 1.439-.18 2.137a5 5 0 1 0-5.71 7.857A8 8 0 0 1 12 21c-4.3-1.088-7-5.57-7-10.364z" /><path fill="currentColor" d="M15.75 13.5h-1.5v1.75H12.5v1.5h1.75v1.75h1.5v-1.75h1.75v-1.5h-1.75z" /></svg>;
export default SvgCreateCoa;